<div class="formula-detail">
  <button mat-button class="formula-detail__back" (click)="goBack()" aria-label="Back to formulas">
    <mat-icon fontIcon="arrow_back" aria-hidden="true"></mat-icon>
    <span>Back to formulas</span>
  </button>

  @if (!loading) {
    @if (notFound) {
      <div class="formula-detail__empty">
        <mat-icon fontIcon="help_outline" aria-hidden="true"></mat-icon>
        <h2>Formula not found</h2>
        <p>The formula you’re looking for doesn’t exist or was removed.</p>
        <button mat-flat-button color="primary" (click)="goBack()">
          <mat-icon fontIcon="arrow_back" aria-hidden="true"></mat-icon>
          Return to list
        </button>
      </div>
    }
    @if (!notFound) {
      <div class="formula-detail__content">
        <div class="formula-detail__header">
          <div class="formula-detail__heading">
            <h1>{{ activeFormulaName }}</h1>
            @if (!isNew && formula?.description) {
              <p class="formula-detail__subtitle">
                {{ formula?.description }}
              </p>
            }
          </div>
          <div class="formula-detail__header-actions">
            <app-aid-year [disabled]="editMode"></app-aid-year>
          </div>
        </div>
        @if (formula && formulaCopy) {
          <app-formula [formula]="editMode ? formulaCopy : formula" [editMode]="editMode" [isNew]="isNew" (edit)="startEdit()" (delete)="confirmDelete()" (saveFormula)="save()" (cancelEdit)="cancel()"></app-formula>
        }
      </div>
    }
  } @else {
    <div class="formula-detail__loading">Loading formula…</div>
  }
</div>
